import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/volcanobet/images/logo.svg';

export default function index() {
  return <Image src={logo} />;
}
